import React from "react";
import {IAuthStore} from "Stores/Auth/types";
import {inject, observer} from "mobx-react";
import {computed} from "mobx";
import {FullWidthFlexBox} from "@src/Shared/Components/FullWidthFlexBox";
import {STTabsContentWrapper} from "@src/Components/Pages/Main/Content/OAuth/styles";
import {Tab, Tabs} from "@material-ui/core";
import {Values} from "Tools/Values";
import Disable2FA from "./Disable2FA/Disable2FA";
import Enable2FA from "./Enable2FA/Enable2FA";

interface IProps {
    auth?: IAuthStore;
}

@inject("auth")
@observer
export default class TwoFactorAuthContent extends React.Component<IProps> {
    @computed get is2FAEnabled() {
        return this.props.auth.user.person.twoFactorAuthenticationEnabled;
    }
    
    render() {
        return (
            <>
                <FullWidthFlexBox>
                    <STTabsContentWrapper>
                        <Tabs
                            value={0}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="standard"
                        >
                            <Tab label={Values.getLocalizationValue('twoFactorAuth')}/>
                        </Tabs>
                    </STTabsContentWrapper>
                </FullWidthFlexBox>

                {this.is2FAEnabled ? (
                    <Disable2FA/>
                ) : (
                    <Enable2FA/>
                )}
            </>
        );
    }
}